import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import SurveyRating from "./components/SurveyRating";
import { nextPage } from "../../store/page/actions";
import { Container } from "./style";
import { WebchatContext } from "../../context/WebchatContext";

const END = "End";

const CustumerExperienceSurvey = ({ config }) => {
  const { isMobile } = useContext(WebchatContext);

  const survey = useSelector((state) => state.survey);
  const [surveyConfig, setSurveyConfig] = useState();
  const dispatch = useDispatch();

  if (survey.active === false) {
    dispatch(nextPage(END));
  }

  useEffect(() => {
    setSurveyConfig({
      survey: { ...survey.survey },
      conversationId: survey.conversationId,
      active: survey.active,
    });
  }, [survey, dispatch]);

  return (
    <Container isMobile={isMobile}>
      {surveyConfig && surveyConfig.active === true && (
        <>
          <SurveyRating
            conversationId={surveyConfig.conversationId}
            surveyConfig={surveyConfig.survey}
            config={config}
          />
        </>
      )}
    </Container>
  );
};

export default CustumerExperienceSurvey;
